import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  `,
  button: css`
    &.MuiToggleButton-root {
      color: ${colors.prussian};
      text-transform: capitalize;
      border: none;
      width: 100%;
      /* line-height: normal;
      border-radius: 20px !important;
      padding: 10px 15px 10px 15px; */
    }

    &.MuiToggleButton-root.Mui-selected {
      color: ${colors.prussian};
      font-weight: bold;
      /* border: 3px solid ${colors.prussian} !important; */
    }
  `,
};

export default styles;
